/**
 * マスタ照会画面専用の型定義
 */

// マスタのカテゴリ定義
export const MasterCategoryConst = {
  SELLER: 'seller',       // 売手
  FARMER: 'farmer',       // 生産者
  BUYER: 'buyer',         // 買手 
  VARIETY: 'variety',     // 品種
  TEA_SEASON: 'teaSeason',// 茶期
  TEA_TYPE: 'teaType',    // 茶種
  GAP: 'gap',             // Gap
  NOTE: 'note',           // 備考
  BLOCK: 'block',         // 管内
  JA: 'ja',               // 農協
  AREA: 'area',           // 地区
} as const;

export type MasterCategoryType = typeof MasterCategoryConst[keyof typeof MasterCategoryConst];

// 検索フィルターの型
export interface MasterSearchFilters {
  code?: string;
  name?: string;
  includeDeleted?: boolean;
}

// 画面表示用に統合したデータ型 (各マスタの共通項 + α)
export interface MasterDisplayRecord {
  [key: string]: any; // 動的にアクセスするため
}